import { downloadBlobFromApi } from '../../helpers'
import Api from '../Api'
import {
  ITestimonialVideoCourseOption,
  ITestimonialVideoListParams,
  ITestimonialVideoListResponse,
  ITestimonialVideoSubmission,
  ITestimonialVideoUpdatePayload,
  TestimonialVideoModality
} from './types'

export class TestimonialVideoService {
  async list(params: ITestimonialVideoListParams): Promise<ITestimonialVideoListResponse> {
    const { data } = await Api.get('/testimonial-videos', {
      params: {
        search: params.search || '',
        modality: params.modality || '',
        course_id: params.course_id || '',
        date: params.date ? JSON.stringify(params.date) : '',
        page: params.page || 1,
        page_size: params.page_size || 25
      }
    })
    return data
  }

  /** Courses that have submissions, for the listing filter. */
  async getFilterCourses(): Promise<ITestimonialVideoCourseOption[]> {
    const { data } = await Api.get('/testimonial-videos/courses')
    return data
  }

  async get(id: number): Promise<ITestimonialVideoSubmission> {
    const { data } = await Api.get(`/testimonial-videos/${id}`)
    return data
  }

  async update(id: number, payload: ITestimonialVideoUpdatePayload): Promise<ITestimonialVideoSubmission> {
    const { data } = await Api.put(`/testimonial-videos/${id}`, payload)
    return data
  }

  async delete(id: number): Promise<void> {
    await Api.delete(`/testimonial-videos/${id}`)
  }

  download(id: number): Promise<void> {
    return downloadBlobFromApi(`/testimonial-videos/${id}/download`, `depoimento-${id}.mp4`)
  }

  // Public endpoints (used by the submission page, no auth required)

  async getFormCourses(modality: TestimonialVideoModality): Promise<ITestimonialVideoCourseOption[]> {
    const { data } = await Api.get('/testimonial-videos/form/courses', { params: { modality } })
    return data
  }

  async getConsentTerm(): Promise<string> {
    const { data } = await Api.get('/testimonial-videos/form/consent-term')
    return data.text
  }

  /** Sends the data and the MP4 in one request; `onProgress` gets the upload percentage. */
  async submit(formData: FormData, onProgress?: (percent: number) => void): Promise<void> {
    await Api.post('/testimonial-videos/form', formData, {
      onUploadProgress: (event) => {
        if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100))
      }
    })
  }
}
